import type { AppEntitlement } from "@/types/app";

import { AppCard } from "./AppCard";
import { AppListRow } from "./AppListRow";
import type { ViewMode } from "./ViewToggle";

type Props = {
  entitlements: AppEntitlement[];
  favorites: Set<string>;
  view: ViewMode;
  onToggleFavorite?: (id: string) => void;
  onLaunch: (entitlement: AppEntitlement) => void;
};

export function AppGrid({
  entitlements,
  favorites,
  view,
  onToggleFavorite,
  onLaunch,
}: Props) {
  if (view === "list") {
    return (
      <div className="flex flex-col gap-2">
        {entitlements.map((e) => (
          <AppListRow
            key={e.appId}
            entitlement={e}
            isFavorite={favorites.has(e.appId)}
            onToggleFavorite={onToggleFavorite}
            onLaunch={onLaunch}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      {entitlements.map((e) => (
        <AppCard
          key={e.appId}
          entitlement={e}
          isFavorite={favorites.has(e.appId)}
          onToggleFavorite={onToggleFavorite}
          onLaunch={onLaunch}
        />
      ))}
    </div>
  );
}
